import Invoice5Container from "../../../../../Components/Applications/Ecommerce/Invoice/Invoice5/Invoice5Container";

const Invoice5 = () => {
  return <Invoice5Container />;
};

export default Invoice5;
